<template>
  <footer class="modern-footer">
    <div class="footer-background">
      <div class="container">
        <div class="row footer-content">
          <div class="col-lg-6 col-md-6 mb-4">
            <div class="company-info">
              <h5 class="company-title">文盛化工</h5>
              <p class="company-description">
                沈阳文盛化工有限公司专业从事化工原料供应，
                致力于为客户提供优质的化工产品和专业的服务。
              </p>
            </div>
          </div>
          
          <div class="col-lg-6 col-md-6 mb-4">
            <div class="contact-info">
              <h6 class="contact-title">联系信息</h6>
              <ul class="contact-list">
                <li class="contact-item">
                  <div class="contact-icon">
                    <b-icon icon="telephone"></b-icon>
                  </div>
                  <span class="contact-text">13149833389</span>
                </li>
                <li class="contact-item">
                  <div class="contact-icon">
                    <b-icon icon="geo-alt"></b-icon>
                  </div>
                  <span class="contact-text">辽宁省沈阳市沈北新区</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div class="footer-divider"></div>
        
        <div class="row footer-bottom">
          <div class="col-md-6">
            <p class="copyright">&copy; 2000 沈阳文盛化工有限公司. 保留所有权利.</p>
          </div>
          <div class="col-md-6 footer-right">
            <div class="beian-info">
              <p class="police-beian-info">
                <img src="/images/police-record.png" alt="公安备案" class="police-icon">
                <a href="https://beian.mps.gov.cn/#/query/websearch?code=21011302000440" target="_blank" rel="noopener noreferrer" class="police-link">
                  辽公网安备21011302000440号
                </a>
              </p>
              <p class="icp-info">
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="icp-link">
                  辽ICP备2025064231号
                </a>
              </p>
            </div>
            <button 
              class="admin-login-btn" 
              @click="goToLogin"
              title="管理员登录"
            >
              <span class="btn-text">管理员登录</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    goToLogin() {
      // 检测是否为移动设备
      const isMobile = this.detectMobileDevice()
      
      if (isMobile) {
        // 移动设备弹窗提示
        this.showMobileWarning()
      } else {
        // 电脑设备正常跳转
        this.$router.push('/login')
      }
    },
    
    detectMobileDevice() {
      const userAgent = navigator.userAgent.toLowerCase()
      
      // 检测移动设备的关键词
      const mobileKeywords = [
        'android', 'iphone', 'ipad', 'ipod', 'blackberry', 
        'windows phone', 'mobile', 'webos', 'opera mini'
      ]
      
      // 检查User Agent是否包含移动设备关键词
      return mobileKeywords.some(keyword => userAgent.includes(keyword))
    },
    
    showMobileWarning() {
      // 使用原生alert显示警告信息
      alert('管理员登录功能仅支持电脑端操作，请在电脑上访问本网站进行管理员登录。')
    }
  }
}
</script>

<style scoped>
.modern-footer {
  position: relative;
  margin-top: 4rem;
  overflow: hidden;
}

.footer-background {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  padding: 3rem 0 2rem;
  position: relative;
}

.footer-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="0.5" fill="%23ffffff" opacity="0.05"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>') repeat;
  pointer-events: none;
}

.footer-content {
  position: relative;
  z-index: 2;
}

.company-info {
  animation: fadeInUp 0.8s ease-out;
}

.company-title {
  color: #ff6b35;
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
}

.company-title::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 50px;
  height: 3px;
  background: linear-gradient(90deg, #ff6b35, #ff8c42);
  border-radius: 2px;
}

.company-description {
  color: #e8e9ea;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 0;
  opacity: 0.9;
}

.contact-info {
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.contact-title {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 1.5rem;
  position: relative;
}

.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  transition: transform 0.3s ease;
}

.contact-item:hover {
  transform: translateX(5px);
}

.contact-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
}

.contact-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);
}

.contact-icon svg {
  color: white;
  font-size: 1.1rem;
}

.contact-text {
  color: #e8e9ea;
  font-size: 1rem;
  font-weight: 500;
}

.footer-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 107, 53, 0.5), transparent);
  margin: 2.5rem 0 2rem;
  position: relative;
}

.footer-divider::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #ff6b35, #ff8c42);
  border-radius: 2px;
}

.footer-bottom {
  align-items: center;
  animation: fadeInUp 0.8s ease-out 0.4s both;
}

.copyright {
  color: #b8b9ba;
  font-size: 0.9rem;
  margin: 0;
  opacity: 0.8;
}

.footer-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1.5rem;
}

.beian-info {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
}

.police-beian-info {
  color: #b8b9ba;
  font-size: 0.9rem;
  margin: 0;
  opacity: 0.8;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.police-icon {
  width: 16px;
  height: 16px;
  opacity: 0.8;
}

.police-link {
  color: #b8b9ba;
  text-decoration: none;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;
}

.police-link:hover {
  color: #ff6b35;
  text-decoration: none;
  border-bottom-color: #ff6b35;
  opacity: 1;
}

.icp-info {
  color: #b8b9ba;
  font-size: 0.9rem;
  margin: 0;
  opacity: 0.8;
}

.icp-link {
  color: #b8b9ba;
  text-decoration: none;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;
}

.icp-link:hover {
  color: #ff6b35;
  text-decoration: none;
  border-bottom-color: #ff6b35;
  opacity: 1;
}

.admin-login-btn {
  background: transparent;
  border: 2px solid #ff6b35;
  color: #ff6b35;
  padding: 0.5rem 1.2rem;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.admin-login-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #ff6b35, #ff8c42);
  transition: left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: -1;
}

.admin-login-btn:hover {
  color: white;
  border-color: #ff8c42;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 107, 53, 0.4);
}

.admin-login-btn:hover::before {
  left: 0;
}

.admin-login-btn:active {
  transform: translateY(0);
}

.btn-icon {
  font-size: 1rem;
  transition: transform 0.3s ease;
}

.admin-login-btn:hover .btn-icon {
  transform: rotate(15deg);
}

.btn-text {
  position: relative;
  z-index: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-background {
    padding: 2rem 0 1.5rem;
  }
  
  .company-title {
    font-size: 1.5rem;
  }
  
  .footer-right {
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    margin-top: 1rem;
  }
  
  .beian-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .contact-item:hover {
    transform: none;
  }
}

@media (max-width: 576px) {
  .footer-right {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .beian-info {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.5rem;
  }
  
  .admin-login-btn {
    margin-top: 0.5rem;
  }
}

/* 动画定义 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 深色主题适配 */
@media (prefers-color-scheme: dark) {
  .footer-background {
    background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #2a2a2a 100%);
  }
}
</style>